<div class="login-content">
  <div class="login-card">
    <div class="login-header">
      <div class="login-logo">
        <img
          src="/assets/images/STLogo_white.png"
          alt="STB Law"
          class="login-logo-image"
        />
      </div>
      <p class="login-subtitle">
        Use your STB Law email and password to sign in.
      </p>
    </div>

    <div class="login-options">
      <button
        class="btn-primary login-button"
        (click)="loginWithMicrosoft()"
        [disabled]="isLoading"
      >
        <svg
          class="icon-sm"
          width="20"
          height="20"
          viewBox="0 0 21 21"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fill-rule="evenodd">
            <path d="M0 0h10v10H0z" fill="#F25022" />
            <path d="M11 0h10v10H11z" fill="#7FBA00" />
            <path d="M0 11h10v10H0z" fill="#00A4EF" />
            <path d="M11 11h10v10H11z" fill="#FFB900" />
          </g>
        </svg>
        <span class="button-text-white" style="color: white !important">
          {{ isLoading ? "Signing in..." : "Sign in via STB Law" }}
        </span>
      </button>

      @if (isLoading) {
      <button type="button" class="cancel-sign-in" (click)="cancelSignIn()">
        Cancel
      </button>
      }
    </div>

    @if (errorMessage) {
    <div class="error-message">
      {{ errorMessage }}
    </div>
    }
  </div>
</div>
